const locale = {
  placeholder: 'Izaberi vreme',
  rangePlaceholder: ['Vreme početka', 'Vreme završetka']
};
export default locale;